export const AUTH_CODE_ANONYMOUS_LOGIN = 'anonymous_login';
export const AUTH_CODE_LOGIN = 'authorization_code';
export const MAGIC_LINK_LOGIN = 'magic_link';
export const PASSWORD_LOGIN = 'password';
export const SSO_LOGIN = 'sso';
